(function SatoriBatchAddressValidation($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('SatoriBatchAddressValidation/index', function onload()
		{
			var $progress_bar   = $('.batch-progress .progress .progress-bar'),
			    progress_timer  = null,
			    update_interval = 1000;

			if ($('div.satori').data('batch-in-progress') === 1) {
				poll();
			}

			$('.satori .batch-intro a.start').click(function startBatch(e) {
				var $self = $(this);
				e.preventDefault();

				Adzuki.CustomConfirm({
					body   : 'Are you sure you want to continue?<br>This action is not reversible, and may take a long time.<br>You can come back to this page at any time.',
					confirm: function startedBatch() {
						Adzuki.Ajax.post('/SatoriBatchAddressValidation/startValidation')
						.then(function startedBatch() {
							$self.prop('disabled', true);
							$('.satori .batch-intro').remove();
							$('.satori .batch-progress').removeClass('hidden');
							poll();
						})
						.catch(function errorStartingBatch(err) {
							Adzuki.StatusMessage('error', 'Error starting validation.');
						});
					}
				});
			});

			$('.satori .batch-results a.new-batch').click(function startNewBatch(e) {
				e.preventDefault();

				Adzuki.CustomConfirm({
					body   : 'By starting a new batch, the current Address Validation Results will no longer be available. Please make sure to download the Address Validation Results before starting a new batch if you want to see which addresses were affected by the current batch.<br>Are you sure you want to continue?',
					confirm: function confirmNewBatch() {
						Adzuki.Ajax.post('/SatoriBatchAddressValidation/startNewBatch')
						.then(function startedBatch() {
							window.location.reload();
						})
						.catch(function errorStartingBatch(err) {
							Adzuki.StatusMessage('error', 'Error starting validation.');
						});
					}
				});
			});



			function poll() {
				progress_timer = setTimeout(function _poll() {
					update_progress();
				}, update_interval);
			}

			function update_progress()
			{
				Adzuki.Ajax.get('/SatoriBatchAddressValidation/progress')
				.then(function updateProgress(data)
				{
					if (data.percent)
					{
						$progress_bar.css('width', data.percent+'%');
						$progress_bar.html(data.percent+'%');

						if (data.percent === 100)
						{
							progress_timer = null;
							window.location.reload();
						}
					}

					if (progress_timer !== null) {
						poll();
					}
				});
			}
		});
	});

}(jQuery, window.Adzuki || {}));